import { setLocale } from '@hejdoktor/resx-compiler';

import { IBootstrappedData } from './interfaces';

const bootstrapped: IBootstrappedData = (window as any).bootstrapped;

setLocale(bootstrapped.CurrentLocale);

export default bootstrapped;
